import { Box, styled } from '@/core/ui';
import { shouldNotForwardProps } from '@/shared/helpers';
export const BoxStyled = styled(Box, shouldNotForwardProps('alignItems'))(({ theme, alignItems }) => ({
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    alignItems: alignItems ?? 'flex-end',
    padding: theme.spacing(4, 0),
    gap: theme.spacing(4),
}));
